type Platform = 'sensors'

export function createTrackConfig() {
  return {
    poizon_activity_invitee_pageview(platform: Platform) {
      if (platform !== 'sensors') return
      console.log('platform', platform)
      return {
        current_page: 979,
        SK: window.dw.getSk(),
      }
    },
    poizon_activity_invite_pageview(platform: Platform) {
      if (platform !== 'sensors') return
      return {
        current_page: 978,
        SK: window.dw.getSk(),
      }
    },
    poizon_activity_invite_click(platform: Platform) {
      if (platform !== 'sensors') return
      return {
        current_page: 978,
        SK: window.dw.getSk(),
      }
    },
  }
}
